import PageHeader from "@/components/page-header";
import { HelpArticlePage } from "@/components/registrant/help/help-portal";
import ErrorComponent from "@/components/ui/error";
import {
  INSPECTION_HELP_PORTAL,
  getInspectionHelpArticle,
  isInspectionHelpArticleId,
} from "@/lib/inspection-help";
import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inspection/help/$articleId")({
  component: InspectionHelpArticle,
});

function InspectionHelpArticle() {
  const { articleId } = Route.useParams();
  const article = isInspectionHelpArticleId(articleId)
    ? getInspectionHelpArticle(articleId)
    : undefined;

  if (!article) {
    return (
      <div className="flex w-full flex-col">
        <PageHeader title="Help Center" className="mb-6" />
        <ErrorComponent
          title="Help topic not found"
          message="That help article does not exist. Open the Help Center to browse topics."
        />
        <Link
          to="/inspection/help"
          className="text-primary mt-4 text-sm font-medium hover:underline"
        >
          All help topics
        </Link>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle={article.title}
        className="mb-6"
      />
      <HelpArticlePage article={article} catalog={INSPECTION_HELP_PORTAL} />
    </div>
  );
}
